export const escapedRegex = (term) => new RegExp(term.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), 'i')